let entitydb = {
  "pinned": [
    "EIN",
    "DealRef",
    "CompanyName",
    "Custodian"
  ],
  "width": {
    "EIN": 94,
    "DealRef": 240,
    "CompanyName": 240,
    "Custodian": 150
  },
  "immutable": {
    "EIN": true,
    "DealRef": true
  },
  "mapping": {
    "ADVFiler": {
      "header": "ADV Filer",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "ADVFiler",
      "element": "dropdown",
      "dropdown": [
        "Yes",
        "No"
      ]
    },
    "ADVStatus": {
      "header": "Form ADV Status",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "ADVStatus",
      "element": "dropdown",
      "dropdown": [
        "Private Fund",
        "Related Person",
        "Not Applicable"
      ]
    },
    "AIFMDReg1": {
      "header": "AIFMD Registration No 1",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "AIFMDReg1"
    },
    "AIFMDReg2": {
      "header": "AIFMD Registration No 2",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "AIFMDReg2"
    },
    "AIFMDReg3": {
      "header": "AIFMD Registration No 3",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "AIFMDReg3"
    },
    "AIFMDReg4": {
      "header": "AIFMD Registration No 4",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "AIFMDReg4"
    },
    "AddCommit": {
      "header": "Additional Commitments",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "AddCommit"
    },
    "AddRegCountry": {
      "header": "Additional Registration Country",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "AddRegCountry"
    },
    "AddRegDate": {
      "header": "Additional Registration Date",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "AddRegDate"
    },
    "AddRegNum": {
      "header": "Additional Registration Number",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "AddRegNum"
    },
    "AggCapCommit": {
      "header": "Aggregate Capital Commitments",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "AggCapCommit"
    },
    "AltTaxID": {
      "header": "Alternate Tax ID",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "AltTaxID"
    },
    "Amend1": {
      "header": "Amendment 1 to LPA/LLC",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "Amend1"
    },
    "AnnRptDueDate": {
      "header": "Annual Report Due Date",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "AnnRptDueDate",
      "element": "dropdown",
      "dropdown": [
        "March 31",
        "June 30",
        "September 30",
        "December 31",
        "Not Applicable"
      ]
    },
    "BalCoEntity": {
      "header": "Balanced/Co-Invest (Multiple Tranche) Entity?",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "BalCoEntity",
      "element": "dropdown",
      "dropdown": [
        "Balanced Only",
        "Co-Investment Only",
        "Balanced/Co-Investment",
        "Multiple Tranches",
        "Balanced/Co-Investment & Multiple Tranches",
        "Not Applicable"
      ]
    },
    "BalCommit": {
      "header": "Total Balanced Commitment",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "BalCommit"
    },
    "BorrowLimit": {
      "header": "Limitations on borrowing",
      "rules": null,
      "dataType": "text",
      "element": "textarea",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "BorrowLimit"
    },
    "CACanDate": {
      "header": "California Registration Cancellation Date",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "CACanDate"
    },
    "CALPNum": {
      "header": "CA LP/LLC Number",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "CALPNum"
    },
    "CARegDate": {
      "header": "California Registration Date",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "CARegDate"
    },
    "CAStatus": {
      "header": "California Registration Status",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "CAStatus",
      "element": "dropdown",
      "dropdown": [
        "Active",
        "Canceled",
        "Not Applicable"
      ]
    },
    "CFTCNoAction": {
      "header": "CFTCNoAction",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "CFTCNoAction"
    },
    "CIKNum": {
      "header": "CIK Number (Central Index Key given by the SEC)",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "CIKNum"
    },
    "CapCallPeriod": {
      "header": "Capital call notification period",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "CapCallPeriod"
    },
    "CarryPct": {
      "header": "Carry Percent",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "CarryPct"
    },
    "CarryTerms": {
      "header": "Carry Terms",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "CarryTerms"
    },
    "CoCommit": {
      "header": "Total Co-Invest Commitment",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "CoCommit"
    },
    "CommodityPool": {
      "header": "Is the entity a commodity pool?",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "CommodityPool",
      "element": "dropdown",
      "dropdown": [
        "Yes",
        "No"
      ]
    },
    "CompanyName": {
      "header": "Company Name",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "CompanyName"
    },
    "Country": {
      "header": "Country",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "Country"
    },
    "Custodian": {
      "header": "Custodian",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "Custodian",
      "element": "dropdown",
      "dropdown": [
        "First Republic Bank",
        "Not Applicable"
      ]
    },
    "DealRef": {
      "header": "Deal Reference",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "DealRef"
    },
    "DissolveDate": {
      "header": "Dissolved Date",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "DissolveDate"
    },
    "EIN": {
      "header": "Employee Identification Number",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "EIN"
    },
    "ERISAPlan": {
      "header": "ERISA Plan Assets (Is the fund a plan asset)?",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "ERISAPlan",
      "element": "dropdown",
      "dropdown": [
        "Yes",
        "No"
      ]
    },
    "EntityType": {
      "header": "Entity Type",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "EntityType",
      "element": "dropdown",
      "dropdown": [
        "Corporation",
        "General Partnership",
        "Limited Liability Company",
        "Limited Liability Partnership",
        "Partnership",
        "Limited Partnership"
      ]
    },
    "ExcessOrgExpAmt": {
      "header": "Excess Organizational Expense Amount",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "ExcessOrgExpAmt"
    },
    "ExcessOrgExpCap": {
      "header": "Excess Organizational Expense Cap?",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "ExcessOrgExpCap",
      "element": "dropdown",
      "dropdown": [
        "Yes",
        "No",
        "Not Applicable"
      ]
    },
    "FATCAReg": {
      "header": "Was the entity registered under FATCA?",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "FATCAReg",
      "element": "dropdown",
      "dropdown": [
        "Yes",
        "No",
        "Not Applicable"
      ]
    },
    "FFARegNum": {
      "header": "Foreign Financial Authority Registration (foreign registration #)",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "FFARegNum"
    },
    "FYEnd": {
      "header": "Fiscal Year End",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "FYEnd",
      "element": "dropdown",
      "dropdown": [
        "March 31",
        "June 30",
        "September 30",
        "December 31"
      ]
    },
    "FinalClose": {
      "header": "Final Closing",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "FinalClose"
    },
    "FinraCRDNum": {
      "header": "FINRA CRD Number",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "FinraCRDNum"
    },
    "ForeignCounsel": {
      "header": "Foreign Counsel",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "ForeignCounsel",
      "element": "dropdown",
      "dropdown": [
        "Maples Corporate Services Limited",
        "King & Wood",
        "Clifford Chance",
        "Torys",
        "Simmons & Simmons",
        "Not Applicable"
      ]
    },
    "FundAuditor": {
      "header": "Fund Auditor",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "FundAuditor",
      "element": "dropdown",
      "dropdown": [
        "Ernst & Young",
        "Burr Pilger Mayer",
        "RSM Malta",
        "PriceWaterhouseCoopers",
        "Deloitte",
        "VRC",
        "Not Applicable"
      ]
    },
    "FundFamily": {
      "header": "Fund Family",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "FundFamily",
      "element": "dropdown",
      "dropdown": [
        "Fund I",
        "Fund II",
        "Fund III",
        "Fund IV",
        "Fund V",
        "Fund VI",
        "Fund VII"
      ]
    },
    "GIIN": {
      "header": "FATCA Registration number (GIIN)",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "GIIN"
    },
    "GP": {
      "header": "General Partner",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "GP"
    },
    "GPCommit": {
      "header": "Total GP Commitments",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "GPCommit"
    },
    "ICAExempt": {
      "header": "Investment Company Act exemption, if applicable, 3c1 or 3c7 fund?",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "ICAExempt",
      "element": "dropdown",
      "dropdown": [
        "3(c)(1)",
        "3(c)(7)",
        "Not Applicable"
      ]
    },
    "InitClose": {
      "header": "Initial Closing",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "InitClose"
    },
    "InvAmtExclusions": {
      "header": "Invested Amount Exclusions",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "InvAmtExclusions"
    },
    "InvEndDate": {
      "header": "Investment Period End Date",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "InvEndDate"
    },
    "InvExt1": {
      "header": "Investment period end date - extension 1",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "InvExt1"
    },
    "InvExtProvisions": {
      "header": "Extensions to Investment Period Provisions",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "InvExtProvisions"
    },
    "InvRestrict": {
      "header": "Investment restrictions",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "InvRestrict"
    },
    "InvStartDate": {
      "header": "Investment Period Start Date",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "InvStartDate"
    },
    "LPCommit": {
      "header": "Total LP Commitments",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "LPCommit"
    },
    "LargeTraderID": {
      "header": "Large Trader Identification Number (Number used for 13H filings)",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "LargeTraderID"
    },
    "LoC": {
      "header": "Line of Credit",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "LoC",
      "element": "dropdown",
      "dropdown": [
        "Yes",
        "No"
      ]
    },
    "LocAmount": {
      "header": "Line of Credit Amount",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "LocAmount"
    },
    "MFeePct": {
      "header": "Management Fee Percentage",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "MFeePct"
    },
    "MFeeStepDate": {
      "header": "Date of Step Down",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "MFeeStepDate"
    },
    "MFeeStepPct": {
      "header": "Management Fee Step-Down Percentage",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "MFeeStepPct"
    },
    "MFeeStepReason": {
      "header": "Reason for Step Down",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "MFeeStepReason"
    },
    "MFeeStepStatus": {
      "header": "Is the management fee in step down?",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "MFeeStepStatus",
      "element": "dropdown",
      "dropdown": [
        "Yes",
        "No",
        "Not Applicable"
      ]
    },
    "MFeeStepVerb": {
      "header": "Management Fee Step Down Verbiage",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "MFeeStepVerb"
    },
    "MFeeWaiverProvisions": {
      "header": "Management Fee Waiver Provisions",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "MFeeWaiverProvisions"
    },
    "MainAddress": {
      "header": "Main Office Address",
      "rules": null,
      "dataType": "text",
      "element": "dropdown",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "MainAddress",
      "dropdown": [
        "One Embarcadero Center, 16th Floor, San Francisco CA 94111, United States",
        "1720 Orchard Lane, Walnut Creek CA, 94595, United States"
      ]
    },
    "MoneyMktAcctRestrict": {
      "header": "Restrictions on money market accounts?",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "MoneyMktAcctRestrict",
      "element": "dropdown",
      "dropdown": [
        "Yes",
        "No",
        "Not Applicable"
      ]
    },
    "PFFiler": {
      "header": "Form PF Filer",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "PFFiler",
      "element": "dropdown",
      "dropdown": [
        "Yes",
        "No"
      ]
    },
    "PartnerEndDate": {
      "header": "Partnership End Date",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "PartnerEndDate"
    },
    "PartnerExt1EndDate": {
      "header": "Partnership end date - extension 1",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "PartnerExt1EndDate"
    },
    "PartnerExt1Pursuant": {
      "header": "Extension 1 pursuant to",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "PartnerExt1Pursuant"
    },
    "PartnerTerm": {
      "header": "Partnership Term",
      "rules": null,
      "dataType": "text",
      "element": "textarea",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "PartnerTerm"
    },
    "PartnerTermExtProvisions": {
      "header": "Partnership Term Extensions Provisions",
      "rules": null,
      "dataType": "text",
      "element": "textarea",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "PartnerTermExtProvisions"
    },
    "PlaceAgent": {
      "header": "Placement Agent",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "PlaceAgent"
    },
    "PreNoticeBorrowList": {
      "header": "Who requires pre-notice of borrowing?",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "PreNoticeBorrowList"
    },
    "PrefReturn": {
      "header": "Preferred Return",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "PrefReturn"
    },
    "PrimeBroker": {
      "header": "Prime Broker",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "PrimeBroker",
      "element": "dropdown",
      "dropdown": [
        "First Republic Bank",
        "Mirae Asset",
        "Not Applicable"
      ]
    },
    "Purpose": {
      "header": "Entity Purpose",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "Purpose",
      "element": "dropdown",
      "dropdown": [
        "AIV",
        "AIV Yukon",
        "Blocker",
        "Carry Vehicle",
        "Co-Investment",
        "Comingled Fund",
        "Feeder Fund",
        "General Partner",
        "Management Company",
        "Parallel Fund",
        "Partner Vehicle",
        "Separate Account",
        "Side Car",
        "Sleeve Fund",
        "SPV"
      ]
    },
    "QualBusIn": {
      "header": "Qualified to do business in",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "QualBusIn"
    },
    "QuickRef": {
      "header": "QuickRef",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "QuickRef"
    },
    "RegAddress": {
      "header": "Registered Office Address",
      "rules": null,
      "dataType": "text",
      "element": "dropdown",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "RegAddress",
      "dropdown": [
        "c/o National Registered Agents, Inc., 160 Greentree Drive, Suite 101, Dover DE 19904, United States",
        "c/o Maples Corporate Services Limited, PO Box 309, Ugland House, Grand Cayman, KY1-1104, Cayman Islands"
      ]
    },
    "RegAgent": {
      "header": "Registered Agent",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "RegAgent",
      "element": "dropdown",
      "dropdown": [
        "National Registered Agents, Inc.",
        "Maples Corporate Services Limited"
      ]
    },
    "RegDate": {
      "header": "Entity Registration Date",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "RegDate"
    },
    "RegNum": {
      "header": "Entity Registration Number",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "RegNum"
    },
    "SAClient": {
      "header": "Separate Account Client",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "SAClient"
    },
    "SECFormDFile": {
      "header": "SEC Form D Filing",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "SECFormDFile",
      "element": "dropdown",
      "dropdown": [
        "Yes",
        "No"
      ]
    },
    "SECFormDNum": {
      "header": "Form D Filing Number",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "SECFormDNum"
    },
    "SECPrivFundID": {
      "header": "SEC Private Fund ID",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "SECPrivFundID"
    },
    "State": {
      "header": "State",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "State"
    },
    "Status": {
      "header": "Company Status",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "Status",
      "element": "dropdown",
      "dropdown": [
        "Active",
        "Dissolved",
        "In Liquidation",
        "Liquidated",
        "Struck Off"
      ]
    },
    "TaxProvider": {
      "header": "Tax Provider",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "TaxProvider",
      "element": "dropdown",
      "dropdown": [
        "Anderson",
        "Deloitte",
        "WTAS",
        "PriceWaterhouseCoopers",
        "Asia Alternatives",
        "Asia Alternatives - Final",
        "Not Applicable"
      ]
    },
    "Tranche1Commit": {
      "header": "Tranche 1 Commitment",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "Tranche1Commit"
    },
    "Tranche2Commit": {
      "header": "Tranche 2 Commitment",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "Tranche2Commit"
    },
    "USCounsel": {
      "header": "US Counsel",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "USCounsel",
      "element": "dropdown",
      "dropdown": [
        "Pillsbury",
        "Ropes & Gray"
      ]
    },
    "8832ElectClass": {
      "header": "8832 Entity Classification Election",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "8832ElectClass",
      "element": "dropdown",
      "dropdown": [
        "A domestic eligible entity electing to be classified as an association taxable as a corporation.",
        "A domestic eligible entity electing to be classified as a partnership.",
        "A domestic eligible entity with a single owner electing to be disregarded as a separate entity.",
        "A foreign eligible entity electing to be classified as an association taxable as a corporation.",
        "A foreign eligible entity electing to be classified as a partnership.",
        "A foreign eligible entity with a single owner electing to be disregarded as a separate entity."
      ]
    },
    "8832ElectDate": {
      "header": "8832ElectDate",
      "rules": null,
      "dataType": "text",
      "meta": null,
      "palceholder": null,
      "validations": null,
      "col": "8832ElectDate"
    }
  }
}
export  { entitydb }
